import React from "react";
import Slider from "./Slider";
import JainFeaturePage from "./JainFeaturePage";
import Email from "./Email";

export default function JainismPage() {
  return (
    <>
      <Email />
      <JainFeaturePage />
      <Slider />
    </>
  );
}
